module.exports = __webpack_public_path__ + "img/mobile-banner2-vn.4cb14d29.jpg";